var render = function render() {
  var _vm = this,
    _c = _vm._self._c,
    _setup = _vm._self._setupProxy
  return _c(
    "div",
    {
      staticClass: "feeds-filter",
      class: { collapse: _setup.collapse, "contents-only": _vm.contentsOnly },
    },
    [
      !_vm.contentsOnly
        ? _c(
            "div",
            {
              staticClass: "feeds-filter-header",
              on: {
                click: function ($event) {
                  _setup.collapse = !_setup.collapse
                },
              },
            },
            [
              _c("h1", [_vm._v("动态过滤")]),
              _vm._v(" "),
              _c(_setup.VIcon, { attrs: { icon: "mdi-chevron-up" } }),
            ],
            1
          )
        : _vm._e(),
      _vm._v(" "),
      _c("h2", [_vm._v("类型")]),
      _vm._v(" "),
      _c(
        "div",
        { staticClass: "filter-types" },
        _vm._l(_setup.allTypes, function ([name, type]) {
          return _c(_setup.FilterTypeSwitch, {
            key: type.id,
            attrs: { name: name, type: type },
          })
        }),
        1
      ),
      _vm._v(" "),
      _c("h2", [_vm._v("关键词")]),
      _vm._v(" "),
      _c(
        "div",
        { staticClass: "filter-patterns" },
        _vm._l(_setup.patterns, function (p) {
          return _c(
            "div",
            {
              key: p.key,
              staticClass: "pattern",
              class: { "pattern-disabled": !p.enabled },
            },
            [
              _c(_setup.TextBox, {
                attrs: { placeholder: "支持正则表达式 /^xxx$/", type: "text" },
                on: {
                  blur: function ($event) {
                    return _setup.savePatternConfig()
                  },
                  keydown: function ($event) {
                    if (
                      !$event.type.indexOf("key") &&
                      _vm._k($event.keyCode, "enter", 13, $event.key, "Enter")
                    )
                      return null
                    return _setup.savePatternConfig()
                  },
                },
                model: {
                  value: p.pattern,
                  callback: function ($$v) {
                    _vm.$set(p, "pattern", $$v)
                  },
                  expression: "p.pattern",
                },
              }),
              _vm._v(" "),
              _c(
                "div",
                { staticClass: "pattern-actions" },
                [
                  _c(_setup.VIcon, {
                    attrs: {
                      title: p.enabled ? "已启用" : "已禁用",
                      icon: p.enabled ? "mdi-check" : "mdi-cancel",
                      size: 16,
                    },
                    nativeOn: {
                      click: function ($event) {
                        return _setup.togglePattern(p)
                      },
                    },
                  }),
                  _vm._v(" "),
                  _c(_setup.VIcon, {
                    attrs: {
                      title: "删除",
                      icon: "mdi-trash-can-outline",
                      size: 16,
                    },
                    nativeOn: {
                      click: function ($event) {
                        return _setup.deletePattern(p)
                      },
                    },
                  }),
                ],
                1
              ),
            ],
            1
          )
        }),
        0
      ),
      _vm._v(" "),
      _c(
        "div",
        { staticClass: "add-pattern" },
        [
          _c(_setup.TextBox, {
            attrs: { placeholder: "支持正则表达式 /^xxx$/", type: "text" },
            on: {
              keydown: function ($event) {
                if (
                  !$event.type.indexOf("key") &&
                  _vm._k($event.keyCode, "enter", 13, $event.key, "Enter")
                )
                  return null
                return _setup.addNewPattern(_setup.newPattern)
              },
            },
            model: {
              value: _setup.newPattern,
              callback: function ($$v) {
                _setup.newPattern = $$v
              },
              expression: "newPattern",
            },
          }),
          _vm._v(" "),
          _c(
            _setup.VButton,
            {
              attrs: { type: "transparent" },
              nativeOn: {
                click: function ($event) {
                  return _setup.addNewPattern(_setup.newPattern)
                },
              },
            },
            [
              _c(_setup.VIcon, {
                attrs: { title: "添加", icon: "mdi-plus", size: 18 },
              }),
            ],
            1
          ),
        ],
        1
      ),
      _vm._v(" "),
      _c("h2", [_vm._v("板块")]),
      _vm._v(" "),
      _c(
        "div",
        { staticClass: "filter-side-card" },
        _vm._l(Object.entries(_setup.allSideCards), function ([id, type]) {
          return _c(_setup.FilterSideCard, {
            key: id,
            attrs: {
              id: parseInt(id),
              name: type.displayName,
              "block-side-cards": _setup.blockSideCards,
            },
            on: {
              click: function ($event) {
                _setup.toggleBlockSide(parseInt(id))
              },
            },
          })
        }),
        1
      ),
    ]
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }